import {
  FetchUnitsSettingsRequest,
  FetchUnitsSettingsSuccess,
  FetchUnitsSettingsFailure,
  UpdateUnitsSettingsRequest,
  UpdateUnitsSettingsSuccess,
  UpdateUnitsSettingsFailure,
} from './units-settings.actions'
import { UnitsSettingsService } from './units-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as UnitsSettingsTypes from './units-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class UnitsSettingsEffects {
  constructor(
    private actions: Actions,
    private unitsSettingsService: UnitsSettingsService,
  ) {}

  FetchPathSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(UnitsSettingsTypes.FETCH_UNITS_SETTINGS_REQUEST),
      switchMap((action: FetchUnitsSettingsRequest) => {
        return this.unitsSettingsService.fetchUnitsSettings().pipe(
          map((result) => {
            return new FetchUnitsSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchUnitsSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateUnitsSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_REQUEST),
      switchMap((action: UpdateUnitsSettingsRequest) => {
        return this.unitsSettingsService
          .updateUnitsSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateUnitsSettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateUnitsSettingsFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
